import { RSAA } from 'redux-api-middleware';
import { createRsaaTypes, createHeaders } from '../actionHelpers';
import queryString from 'query-string';

export const ADMIN_STORAGE_SITES_SEARCH = 'ADMIN_STORAGE_SITES_SEARCH';
export const ADMIN_STORAGE_SITES_SEARCH_SUCCESS = 'ADMIN_STORAGE_SITES_SEARCH_SUCCESS';
export const ADMIN_STORAGE_SITES_SEARCH_FAILURE = 'ADMIN_STORAGE_SITES_SEARCH_FAILURE';
export const ADMIN_STORAGE_SITES_GET = 'ADMIN_STORAGE_SITES_GET';
export const ADMIN_STORAGE_SITES_SET_SEARCH_PARAMETERS = 'ADMIN_STORAGE_SITES_SET_SEARCH_PARAMETERS';
export const ADMIN_STORAGE_SITES_UPDATE = 'ADMIN_STORAGE_SITES_UPDATE';
export const ADMIN_STORAGE_SITES_SYNCHRONIZE_WITH_LOCK_SYSTEM = 'ADMIN_STORAGE_SITES_SYNCHRONIZE_WITH_LOCK_SYSTEM';
export const ADMIN_STORAGE_SITES_SEND_ROUND_REPORT = 'ADMIN_STORAGE_SITES_SEND_ROUND_REPORT';
export const ADMIN_STORAGE_SITES_FETCH_SUBSCRIPTION_BOKING_PRICE_OVERVIEW = 'ADMIN_STORAGE_SITES_FETCH_SUBSCRIPTION_BOKING_PRICE_OVERVIEW';
export const ADMIN_STORAGE_SITES_FETCH_PRICE_AFFECTED_BOOKINGS = 'ADMIN_STORAGE_SITES_FETCH_PRICE_AFFECTED_BOOKINGS';
export const ADMIN_STORAGE_SITES_CREATE_PRICE_ADJUSTMENT = 'ADMIN_STORAGE_SITES_CREATE_PRICE_ADJUSTMENT';

export const searchStorageSites = searchParameters => ({
    [RSAA]: {
        types: createRsaaTypes(ADMIN_STORAGE_SITES_SEARCH),
        endpoint: `/api/admin/storageSites?${queryString.stringify(searchParameters)}`,
        headers: createHeaders(false),
        method: 'GET'
    }
});

export const getStorageSite = storageSiteId => ({
    [RSAA]: {
        types: createRsaaTypes(ADMIN_STORAGE_SITES_GET),
        endpoint: `/api/admin/storageSites/${storageSiteId}`,
        headers: createHeaders(false),
        method: 'GET'
    }
});

export const updateStorageSite = (storageSiteId, request) => ({
    [RSAA]: {
        types: createRsaaTypes(ADMIN_STORAGE_SITES_UPDATE),
        endpoint: `/api/admin/storageSites/${storageSiteId}`,
        headers: createHeaders(true),
        method: 'PUT',
        body: JSON.stringify(request)
    }
});

export const getStorageSiteSubscriptionBookingPriceOverview = storageSiteId => ({
    [RSAA]: {
        types: createRsaaTypes(ADMIN_STORAGE_SITES_FETCH_SUBSCRIPTION_BOKING_PRICE_OVERVIEW),
        endpoint: `/api/admin/storageSites/${storageSiteId}/subscriptionBookingPriceOverview`,
        headers: createHeaders(false),
        method: 'GET'
    }
});

export const synchronizeStorageSiteWithLockSystem = storageSiteId => ({
    [RSAA]: {
        types: createRsaaTypes(ADMIN_STORAGE_SITES_SYNCHRONIZE_WITH_LOCK_SYSTEM),
        endpoint: `/api/admin/storageSites/${storageSiteId}/lockSystem/synchronize`,
        headers: createHeaders(false),
        method: 'PUT'
    }
});

export const sendRoundReport = storageSiteId => ({
    [RSAA]: {
        types: createRsaaTypes(ADMIN_STORAGE_SITES_SEND_ROUND_REPORT),
        endpoint: `/api/admin/storageSites/${storageSiteId}/roundReports`,
        headers: createHeaders(false),
        method: 'POST'
    }
});

export const createPriceAdjustment = (storageSiteId, request) => ({
    [RSAA]: {
        types: createRsaaTypes(ADMIN_STORAGE_SITES_CREATE_PRICE_ADJUSTMENT),
        endpoint: `/api/admin/storageSites/${storageSiteId}/priceAdjustments`,
        headers: createHeaders(true),
        method: 'POST',
        body: JSON.stringify(request)
    }
});

export const fetchPriceAffectedBookings = (storageSiteId, date, percentage, amountDifference) => ({
    [RSAA]: {
        types: createRsaaTypes(ADMIN_STORAGE_SITES_FETCH_PRICE_AFFECTED_BOOKINGS),
        endpoint: `/api/admin/storageSites/${storageSiteId}/priceAffectedBookings?${queryString.stringify({ date, percentage, amountDifference })}`,
        headers: createHeaders(false),
        method: 'GET'
    }
});

export const setSearchParameters = searchParameters => ({
    type: ADMIN_STORAGE_SITES_SET_SEARCH_PARAMETERS,
    searchParameters
});
